export const state = {
  dialog: {
    active: false
  },
  payments: {
    data: []
  },
  error: {
    show: false,
    type: 'success',
    message: ''
  }
}

export type State = typeof state
